export default __webpack_public_path__ + "static/freshsale-5596fc0b8f6bb1c38790536e7c2b3a6c.png";